import ManageMake from './manageMake'

export default ManageMake
